export const skinCustom = {
  lightComponents: {
    body: '#f1f1f1',
    gradient: {
      gradientDefault1: '#5c7c5c',
      gradientDefault2: '#1f6923',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal:
    'https://despachanteparana.com.br/image-bank/logo-parana-login.png',
  favicon:
    'https://despachanteparana.com.br/image-bank/favicon-parana-despachante-1.webp',
}

export const seo = {
  titulo: 'Despachante Parana',
  email: 'suporte@senhadigital.com.br',
  palavrasChave:
    'Certificado Digital, Cnpj a1, Cpf a1, emitir certificado, certificado Blumenau',
  descricao:
    'Empresa líder em Certificação Digital, oferecendo soluções seguras e confiáveis para empresas e indivíduos, com ampla experiência no mercado.',
  descricaoPWA:
    'Certificados digitais são identidades eletrônicas seguras usadas para autenticar usuários, proteger informações e realizar transações online com segurança.',
}

export const header = {
  empresa: false,
  solucoes: false,
  empresa: false,
  solucoes: false,
  contato: true,
  trabalheConosco: false,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: false,
  darkMode: false,
  contaLogin: true,
}

export const contentHome = {
  sispass: false,
  produtorRural: false,
  modalidadesCertificado: false,
  sispass: false,
  produtorRural: false,
  modalidadesCertificado: false,
}

export const footer = {
  is0800: false,
  telefone: '41 3015-5501',
  whatsapp: '41 9926-1312',
  botaoRenocao: '4199261312',
  botaoWhatsapp: '4199261312',
  number0800: '0800 600 2710',
  cidadeuf: 'Curitiba/PR',
  cidade: 'Curitiba',
  bairro: 'Rebouças',
  titulo: 'Certificado Digital em Curitiba',
  rua: 'Rua Alferes Poli',
  numero: '1391',
  complemento: '',
  cep: '80220-050',
  cnpj: '',
  messageContador: 'Olá, tenho interesse em ser Parceiro Indicador.',
  messageRevenda: 'Olá, tenho interesse em revender Certificados Digitais',
  messageAgendamento:
    'Olá, estou no site da Qcertifica e gostaria de agendar a emissão do meu Certificado Digital.',
  messageRenovacao: 'Olá, gostaria de renovar meu Certificado Digital',
  messageRenovacaoSispass:
    'Olá, gostaria de renovar meu Certificado Digital Sispass',
  messageConhecaNossasSolucoes:
    'Olá, gostaria de conhecer as soluções da Senha Digital',
}

export const redes = {
  facebook: 'https://www.facebook.com/paranadespachante',
  instagram: 'https://www.instagram.com/paranadespachante/',
  linkedin: 'https://www.linkedin.com/company/parana-despachante/about/',
}

export const digisac = {
  id: 'df7a6a14-269a-46ba-a874-33c45e74badf',
  status: false,
  status: false,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
